import React, { useState } from 'react';
import {
  Box,
  Radio,
  FormControlLabel,
  RadioGroup,
  Typography,
} from '@mui/material';
import { RadioBtnActiveIcon, RadioBtnNonActiveIcon } from '../../icons';

const RadioBoxGroup = ({
  options = [],
  defaultValue,
  row = false, // new prop to control layout
}) => {
  const [selectedOption, setSelectedOption] = useState(
    defaultValue || (options.length > 0 ? options[0] : '')
  );

  const handleChange = (event) => {
    setSelectedOption(event.target.value);
  };

  return (
    <RadioGroup value={selectedOption} onChange={handleChange} row={row} sx={{ gap: row ? '4px' : '0px', flexWrap: 'nowrap' }}>
      {options.map((option) => (
        <FormControlLabel
          key={option}
          value={option}
          control={
            <Radio
              icon={<RadioBtnNonActiveIcon />}
              checkedIcon={<RadioBtnActiveIcon sx={{ color: '#0076FE' }} />}
              sx={{ padding: 0, paddingRight: row ? 0 : 0, marginBottom: row ? 0 : 0 }}
            />
          }
          label={option}
          sx={{
            marginBottom: row ? '0px' : '8px',
            marginLeft: '0',
            marginRight: { xl: '16px', lg: '14px', md: '5px', sm: '5px', xs: '5px' },
            gap: { xl: '7px', lg: '5px', md: '3px', sm: '3px', xs: '3px' },
            display: 'flex', alignItems: 'center',
            '.MuiFormControlLabel-label': {
              fontSize: '13px',
              display: 'flex', alignItems: 'center',
            },
          }}
        />
      ))}
    </RadioGroup>
  );
};

export default RadioBoxGroup;
